import ContextMenu from "@atlas/uicorn/lib/Control/ContextMenu";
import CalendarIcon from "@atlas/uicorn/lib/Icon/CalendarIcon";
import ClockIcon from "@atlas/uicorn/lib/Icon/ClockIcon";
import React, { useMemo } from "react";
import IconButton from "@atlas/uicorn/lib/Control/IconButton";
import SortIcon from "@atlas/uicorn/lib/Icon/SortIcon";
import useRefCallback from "use-ref-callback";
import t from "../../../texts/t";

const SortMenu = function SortMenu({
  sort,
  onChange,
  language,
}: TSortMenuProps) {
  const menuItems = useMemo(
    () => [
      {
        key: SortField.createdAt,
        label: t("Created at", language),
        icon: <CalendarIcon size={20} />,
      },
      {
        key: SortField.lastMessageAt,
        label: t("Last message time", language),
        icon: <ClockIcon size={20} />,
      },
    ],
    [language]
  );

  const [sortField, sortOrder = "desc"] = sort.split(":") as [
    SortField,
    SortDirection
  ];

  const selected = useMemo(
    () => menuItems.filter((item) => item.key === sortField),
    [sort, menuItems, sortField]
  );

  const handleChoose = useRefCallback(({ key: newSortField }) => {
    const newSort =
      sortField === newSortField
        ? sortField + (sortOrder === "desc" ? ":asc" : ":desc")
        : newSortField + ":desc";

    onChange(newSort);
  });

  return (
    <ContextMenu
      items={menuItems}
      selected={selected}
      onChoose={handleChoose}
      placement="bottom-end"
      strategy="fixed"
    >
      <IconButton
        size={24}
        icon={
          <SortIcon
            sortOrder={sortOrder}
            color={sortField ? "primary" : "grey8"}
          />
        }
        tooltip=""
      />
    </ContextMenu>
  );
};

export default SortMenu;

// #region Types

enum SortField {
  createdAt = "created_at",
  lastMessageAt = "last_message_at",
}

type SortDirection = "asc" | "desc";

type TSortMenuProps = {
  sort: string;
  onChange: (sort: string) => void;
  language?: string;
};

// #endregion
